import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ecf40de&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4ecf40de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecf40de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecf40de')) {
      api.createRecord('4ecf40de', component.options)
    } else {
      api.reload('4ecf40de', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ecf40de&scoped=true&", function () {
      api.rerender('4ecf40de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/BuildingList/index.vue"
export default component.exports